import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:manageWhiteList
 * @description
 * # manageWhiteList
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('manageWhiteList', ($ngRedux, $rootScope, $scope, $location, $route, $http, ENV) => {
    if (!$scope.isSuperUser) {
      $location.path('/');
    }

    $scope.processParams = () =>
      new Promise((resolve) => {
        const { ipWhitelistId } = $route.current.params;
        $scope.takeAction(ipWhitelistId);
        resolve(true);
      });

    $scope.takeAction = (id) => {
      if (!id) return;

      if (id === 'create-ip-whitelist') {
        $scope.open(id);
      } else if (id) {
        $scope
          .getIpWhitelist($http, ENV, id)
          .then(() => {
            $scope.open(id);
          })
          .catch(() => {
            const errorModalOptions = {
              heading: 'IP Whitelist Error',
              message: `${id} is not available at this time.  It either does not exist or has caused an error.  Please try again later or contact support if the error persists.`,
              buttons: [
                {
                  label: 'Close',
                  href: '#',
                  clickFn: () => {
                    $rootScope.toggleErrorModal();
                    $location.path($rootScope.routes.whitelist, false);
                  },
                },
              ],
            };
            $rootScope.toggleErrorModal(errorModalOptions);
          });
      }
    };

    $scope.open = (id) => {
      const component = id === 'create-ip-whitelist' ? 'create-ip-whitelist' : 'edit-ip-whitelist';
      const closeRoute = $rootScope.previousRoute || $rootScope.routes.whitelist;
      const beforeRoute = `${$rootScope.routes.whitelist}/${id}`;
      $rootScope.openComponent({
        component: component,
        beforeRoute: beforeRoute,
        closeRoute: closeRoute,
      });
    };

    $scope.init = () => {
      $rootScope.previousRoute = $rootScope.routes.whitelist;
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      $scope.processParams();
    };

    $scope.table = {
      name: 'Manage Third Party IP Whitelist',
      options: {
        endpoint: '/2.0/third-party/white-list/',
        endpoint_data_key: 'ip-white-lists',
        per_page_options: [15, 25, 50, 100, 200],
        records_per_page: 15,
        row_style: 'standard',
        scale_up: false,
        search_key: null,
        search_required: false,
      },
      actions: [
        {
          name: 'Add a New Whitelisted IP',
          link: '#',
          onclick: () => {
            $scope.takeAction('create-ip-whitelist');
          },
          order: 0,
          superuser: true,
        },
      ],
      columns: [
        {
          name: 'Name',
          options: {
            content: '{{ record.name }}',
            class: 'limit-width',
          },
        },
        {
          name: 'IP Address/Range',
          options: {
            content: '{{ record.ip_address }}',
            class: 'minimum-width',
          },
        },
        {
          name: 'Created',
          options: {
            content: '{{ record.created }}',
            class: '',
          },
        },
        {
          name: 'Updated',
          options: {
            content: '{{ record.updated }}',
            class: '',
          },
        },
        {
          name: 'Action',
          options: {
            content: '<a href="#" ng-click="takeAction(record.id)">Edit Whitelist Entry</a>',
            class: 'td-action',
          },
        },
      ],
      filters: [
        {
          name: 'Created Timeframe',
          type: 'single_choice',
          options: {
            choices: {
              'Last 24 Hours': { type: 'standard', state: false, value: 'day', order: 0 },
              'Previous Week': { type: 'standard', state: false, value: 'week', order: 1 },
              'Previous 365 Days': { type: 'standard', state: false, value: 'year', order: 2 },
              All: { type: 'standard', state: true, value: 'all', order: 3 },
              'Custom Range': {
                type: 'range',
                state: false,
                value: 'range',
                from: '',
                to: '',
                date_field: true,
                order: 4,
                error: false,
              },
            },
            class: 'timeframe-filter',
            query_string_parameter: 'created',
          },
        },
        {
          name: 'Updated Timeframe',
          type: 'single_choice',
          options: {
            choices: {
              'Last 24 Hours': { type: 'standard', state: false, value: 'day', order: 0 },
              'Previous Week': { type: 'standard', state: false, value: 'week', order: 1 },
              'Previous 365 Days': { type: 'standard', state: false, value: 'year', order: 2 },
              All: { type: 'standard', state: true, value: 'all', order: 3 },
              'Custom Range': {
                type: 'range',
                state: false,
                value: 'range',
                from: '',
                to: '',
                date_field: true,
                order: 4,
                error: false,
              },
            },
            class: 'timeframe-filter',
            query_string_parameter: 'updated',
          },
        },
      ],
      sort_options: {
        created: {
          state: false,
          value: '-1',
          title: 'Whitelist Entry Created',
          order: 0,
        },
        updated: {
          state: true,
          value: '-1',
          title: 'Whitelist Entry Updated',
          order: 1,
        },
        name: {
          state: false,
          value: '1',
          title: 'Whitelist Entry Name',
          order: 2,
        },
        ip_address: {
          state: false,
          value: '1',
          title: 'Whitelist Entry IP Address',
          order: 3,
        },
      },
    };

    $scope.init();

    $scope.$on('$destroy', $scope.unsubscribe);
  });
